import { createSvgIcon } from './utils';

export default createSvgIcon(
  <path d="M1.35518415,8.33214491 L16.6428047,8.33214491 C17.231025,8.33214491 17.7073002,8.80842013 17.7073002,9.39664039 L17.7073002,9.44548913 C17.7073002,10.0337094 17.231025,10.5099846 16.6428047,10.5099846 L1.35518415,10.5099846 C0.766963895,10.5099846 0.290688669,10.0337094 0.290688669,9.44548913 L0.290688669,9.39664039 C0.290688669,8.80842013 0.766963895,8.33214491 1.35518415,8.33214491 L1.35518415,8.33214491 Z" />,
  'Minimize'
);
